import axios from "axios";
import configData from ".././config.json"
import {PositionMarkerApiRequest} from "../models/PositionMarkerModel";

export const getAPIPositionMarkerFilter = async(model : PositionMarkerApiRequest) => {
    try{
        const PositionMarker = await  axios.post(configData.API_URL + "/positionMarker", model)
        return PositionMarker;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }
     
  };

export const getAPIPositionMarkerDetail = async(id : number, year:number ) => {
    try{
        let _year=year;
        const PositionMarker = await  axios.get(configData.API_URL + "/positionMarker/detail?positionMarkerId=" + id + "&positionMarkerYear=" + _year)
        return PositionMarker;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};

